var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('label',{staticClass:"switch"},[_c('input',_vm._b({attrs:{"type":"checkbox"},on:{"change":_vm.onChange}},'input',_vm.$attrs,false)),_c('span',{staticClass:"slider round"})])
}
var staticRenderFns = []

export { render, staticRenderFns }